import { useMediaGallery } from '$partials/media/media-gallery';
import { Media } from '$partials/media';

import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').ImageGridBlock}
 */
const ImageGrid = ({
    images,
    layout
}) => {
    const {setInitId} = useMediaGallery();
    if (!images?.length) { return null; }

    if (layout === 'full_width') {
        return (
            <div className='w-full'>
                {images.map((itm, idx) => {
                    const onclick = () => {
                        setInitId(itm.id);
                    };
                    return (
                        <div
                            className='cursor-pointer'
                            key={itm.id}
                            onClick={() => itm?.image && setInitId(itm.id)}>
                            <Media  {
                                ...{
                                    ...itm,
                                    ...(itm?.image ? {
                                        image: {
                                            ...itm?.image,
                                        }
                                    } : {} ),
                                    ...(itm?.videoEmbed ? {
                                        videoEmbed: {
                                            ...itm?.videoEmbed,
                                            disablePlay: true,
                                            autoplay: true,
                                            loop:true,
                                            onclick: onclick,
                                            poster: itm?.videoEmbed?.poster || itm?.videoEmbed?.embed?.thumbnailUrl,
                                        }
                                    } : {} ),
                                    ...(itm?.video ? {
                                        video: {
                                            ...itm?.video,
                                            disablePlay: true,
                                            autoplay: true,
                                            loop:true,
                                            onclick: onclick,
                                        }
                                    } : {} )
                                }
                            }/>
                        </div>
                    );
                })}
            </div>
        );
    }


    return (
        <>
            {/* Desktop */}
            <div className='hidden sm:flex'>
                <div className={layout === 'large_left' ? 'w-4/7' : 'w-3/7'}>
                    {images.map((itm, idx) => {
                        if (layout === 'large_left' && idx === images.length - 1 ) {
                            return null;
                        }
                        if ((layout === 'large_right' && idx % 2 === 0) || idx % 2 === 0) {
                            const onclick = () => {
                                setInitId(itm.id);
                            };
                            return (
                                <div
                                    className='cursor-pointer'
                                    key={itm.id}
                                    onClick={() => itm?.image && setInitId(itm.id)}>
                                    <Media  {
                                        ...{
                                            ...itm,
                                            ...(itm?.image ? {
                                                image: {
                                                    ...itm?.image,
                                                }
                                            } : {} ),
                                            ...(itm?.videoEmbed ? {
                                                videoEmbed: {
                                                    ...itm?.videoEmbed,
                                                    disablePlay: true,
                                                    autoplay: true,
                                                    loop:true,
                                                    onclick: onclick,
                                                    poster: itm?.videoEmbed?.poster || itm?.videoEmbed?.embed?.thumbnailUrl
                                                }
                                            } : {} ),
                                            ...(itm?.video ? {
                                                video: {
                                                    ...itm?.video,
                                                    disablePlay: true,
                                                    autoplay: true,
                                                    loop:true,
                                                    onclick: onclick
                                                }
                                            } : {} )
                                        }
                                    }/>
                                </div>
                            );
                        }
                    })}
                </div>
                <div className={layout === 'large_right' ? 'w-4/7' : 'w-3/7'}>
                    {images.map((itm, idx) => {
                        if ((layout === 'large_left' && idx === images.length - 1 ) || idx % 2 !== 0) {
                            const onclick = () => {
                                setInitId(itm.id);
                            };
                            return (
                                <div
                                    className='cursor-pointer'
                                    key={itm.id}
                                    onClick={() => itm?.image && setInitId(itm.id)}>
                                    <Media  {
                                        ...{
                                            ...itm,
                                            ...(itm?.image ? {
                                                image: {
                                                    ...itm?.image,
                                                }
                                            } : {} ),
                                            ...(itm?.videoEmbed ? {
                                                videoEmbed: {
                                                    ...itm?.videoEmbed,
                                                    disablePlay: true,
                                                    autoplay: true,
                                                    loop:true,
                                                    onclick: onclick,
                                                    poster: itm?.videoEmbed?.poster || itm?.videoEmbed?.embed?.thumbnailUrl
                                                }
                                            } : {} ),
                                            ...(itm?.video ? {
                                                video: {
                                                    ...itm?.video,
                                                    disablePlay: true,
                                                    autoplay: true,
                                                    loop:true,
                                                    onclick: onclick
                                                }
                                            } : {} )
                                        }
                                    }/>
                                </div>
                            );
                        }
                    })}
                </div>
            </div>

            {/* Mobile */}
            <div className='sm:hidden'>
                <div className='w-full'>
                    {images.map((itm, idx) => {
                        const onclick = () => {
                            setInitId(itm.id);
                        };
                        return (
                            <div
                                key={itm.id}
                                onClick={() => itm?.image && setInitId(itm.id)}>
                                <Media  {
                                    ...{
                                        ...itm,
                                        ...(itm?.image ? {
                                            image: {
                                                ...itm?.image,
                                            }
                                        } : {} ),
                                        ...(itm?.videoEmbed ? {
                                            videoEmbed: {
                                                ...itm?.videoEmbed,
                                                disablePlay: true,
                                                autoplay: true,
                                                loop:true,
                                                onclick: onclick,
                                                poster: itm?.videoEmbed?.poster || itm?.videoEmbed?.embed?.thumbnailUrl
                                            }
                                        } : {} ),
                                        ...(itm?.video ? {
                                            video: {
                                                ...itm?.video,
                                                disablePlay: true,
                                                autoplay: true,
                                                loop:true,
                                                onclick: onclick
                                            }
                                        } : {} )
                                    }
                                }/>
                            </div>
                        );
                    })}
                </div>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ImageGrid;
